import { render, staticRenderFns } from "./DisableIntegration.vue?vue&type=template&id=38e1046e"
import script from "./DisableIntegration.vue?vue&type=script&lang=js"
export * from "./DisableIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports